import { PermissionsType } from '@/common/permissionsConst';
import InComingOverview from '.';
import { Themes } from '@maxtropy/components';

const routes = [
  {
    path: '/energyAssets/energygateway',
    permission: PermissionsType.P_ENERGY_ASSERT_PORTAL,
    theme: Themes.DARK,
    element: <InComingOverview />,
  },
];

export default routes;
